'use client';

import AppBar from '@enlighten/design-system/dist/AppBar';
import Button from '@enlighten/design-system/dist/Button';
import Grid from '@enlighten/design-system/dist/Grid';
import List from '@enlighten/design-system/dist/List';
import ListItem from '@enlighten/design-system/dist/ListItem';
import ListItemButton from '@enlighten/design-system/dist/ListItemButton';
import Typography from '@enlighten/design-system/dist/Typography';
import LaunchIcon from '@mui/icons-material/Launch';
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';

import KrIcon from '@/assets/images/intl/kr-icon.svg';
import { enNavigationList } from '@/constants/navigation';

export default function DesktopHeader() {
	const router = useRouter();
	const pathname = usePathname();

	return (
		<AppBar
			sx={{
				display: 'flex',
				alignItems: 'center',
				bgcolor: 'common.white',
				height: 96,
				zIndex: 998,
				boxShadow: '0 4px 28px #0000001A',
				transition: 'all 0.3s ease',
			}}
		>
			<Grid container flexWrap="nowrap" justifyContent="space-between" alignItems="center" maxWidth={1440} width="100%" height="100%" padding="0 24px">
				<Grid display="flex" justifyContent="space-between" alignItems="center" minWidth="auto" height="100%">
					<Link href="/en/about" aria-label="ENlighten" style={{ display: 'flex', alignItems: 'center', width: 'fit-content', height: '100%' }}>
						<Grid
							width={158}
							height={26}
							sx={{
								backgroundImage: 'url(/logo.svg)',
								backgroundRepeat: 'no-repeat',
								backgroundSize: 'cover',
								filter: 'none',
							}}
						/>
					</Link>
				</Grid>
				<List
					sx={{
						display: 'flex',
						justifyContent: 'center',
						maxWidth: 1038,
						width: '100%',
						padding: 0,
					}}
				>
					{enNavigationList.map((props, i) => (
						<ListItem
							key={i}
							className={props.href === pathname ? 'active' : undefined}
							sx={{
								width: 'fit-content',
								height: 46,
								padding: 0,
								'&.MuiListItem-root': {
									height: '100%',
								},
								':hover, &.active': {
									'.MuiTypography-root': {
										color: 'primary.main',
									},
								},
							}}
						>
							<Grid container alignItems="center" height={96}>
								<ListItemButton
									LinkComponent={Link}
									{...props}
									title={props.title}
									sx={{
										height: '100%',
										padding: '0 20px',
										':hover': {
											bgcolor: 'transparent',
										},
									}}
								>
									<Typography fontWeight={700} fontSize={17}>
										{props.title}
									</Typography>
								</ListItemButton>
							</Grid>
						</ListItem>
					))}
				</List>
				<Button
					variant="outlined"
					onClick={() => {
						router.push('/');
					}}
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						minWidth: 90,
						height: 'fit-content',
						borderWidth: 1,
						borderColor: 'primary.main',
						borderRadius: 99,
						padding: '4px 12px',
					}}
				>
					<KrIcon />
					<Typography fontSize={12} fontWeight={500} color="primary.main" marginLeft="4px" marginRight={1}>
						KR
					</Typography>
					<LaunchIcon fontSize="small" sx={{ fill: '#6400FF' }} />
				</Button>
			</Grid>
		</AppBar>
	);
}
